(() => {
  const SEL = '.jdgm-widget.jdgm-cards-carousel';

  const apply = () => {
    document.querySelectorAll(SEL).forEach(el => {
      el.style.setProperty('--max-width', '100%', 'important');
      el.style.setProperty('--width-xs', '390px', 'important');
      el.style.setProperty('--slides-count', '5', 'important');
      // if needed across breakpoints:
      // el.style.setProperty('--width-sm', '320px', 'important');
      // el.style.setProperty('--width-md', '320px', 'important');
      // el.style.setProperty('--width-lg', '320px', 'important');
      // el.style.setProperty('--width-xl', '320px', 'important');
      // el.style.setProperty('--slides-count', '4', 'important');
    });
  };

  apply();
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);

  new MutationObserver(apply).observe(document.documentElement, {
    subtree: true,
    childList: true
  });
})();